module.exports = require('./dist/elo-rating');